/**
    商品列表
**/
<template>
  <div class="rightaside_content">
    <h3 class="headerTitle">我的足迹</h3>
    <el-row :gutter="20" v-loading="loading">
      <el-col :span="6" v-for="item in goodsList" :key="item.id">
        <goodsCard :bigImgSize='0' :isAddCart='0' :isOpenCart='1' :item='item' :getcollectionList='getfootList'></goodsCard>
        <!-- <div class="wholeInfoBox">
          <div>
            <el-image :src="item.photos">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <div class="attentiontOpreate">
              <el-button
                type="warning"
                icon="el-icon-star-off"
                circle
              ></el-button>
              <el-button
                @click="openGoodsInfo"
                type="warning"
                icon="el-icon-search"
                circle
              ></el-button>
            </div>
            <div class="addCartOpreate">
              <span @click="addCart"
                ><i class="el-icon-shopping-cart-2"></i>加入购物车</span
              >
            </div>
            <div class="goodsText">
              <router-link :to="`/goodsdetail?id=${item.id}`"
                ><p class="OneLineDisplay">{{ item.name }}</p></router-link
              >
              <p class="OneLineDisplay" style="color: #78b942; margin: 3px 0">
                {{ item.realprice }} 元
              </p>
              <p class="OneLineDisplay">{{ item.evaluator }} 人评价</p>
              <div class="mark">
                <div
                  class="redeemNow"
                  @click="
                    $router.push(`/gotoEvaluation?evaluationId=${item.id}`)
                  "
                >
                  去评价
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </el-col>
      <el-col v-if="goodsList.length == 0 ? true : false">
        <div class="no_goods">
          <el-image :src="require('@/assets/img/no_goods.png')" fit="fill">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <p>暂无您的收藏商品</p>
          <p>可以去看看哪些想收藏的</p>
          <router-link to="/"
            ><p class="OneLineDisplay">随便逛逛</p></router-link
          >
        </div>
      </el-col>
    </el-row>

    <!-- 打开商品详情信息 开始 -->
    <!-- <el-dialog
      class="addCartInfoBox"
      :visible.sync="openGoodsVisible"
      center
      :before-close="beforeClose"
      width="60%"
    >
      <el-row style="margin-bottom: 20px">
        <el-col :span="8">
          <div class="fl">
            <div class="fl second-img" id="secondimg">
              <div id="smallBox">
                <ul class="smallimg fl">
                  <li>
                    <el-image
                      id="smallBox_img"
                      :src="`${info.photos}`"
                      alt="picture"
                    ></el-image>
                  </li>
                </ul>
                <div class="left-arr" id="left-arr"></div>
                <div class="right-arr" id="right-arr"></div>
                <div class="fangdj fl" id="mask"></div>
              </div>
              <div class="bigbox" id="bigbox">
                <img
                  id="bigBox_img"
                  src="https://www.xunyoutest.com/image.php/shop/data/upload/media/store/13/image/20200723/1595488198898831.jpg!800x800.jpg"
                  alt=""
                />
              </div>
            </div>
            <div class="smallnav">
              <ul class="smnav" id="smnav">
                <li class="active">
                  <el-image
                    :src="`${info.photos}`"
                    alt=""
                  ></el-image>
                </li>
                <li>
                  <el-image
                    :src="`${info.photos}`"
                    alt=""
                  ></el-image>
                </li>
                <li>
                  <el-image
                    :src="`${info.photos}`"
                    alt=""
                  ></el-image>
                </li>
                <li>
                  <el-image
                    :src="`${info.photos}`"
                    alt=""
                  ></el-image>
                </li>
                <li>
                  <img
                    src="https://www.xunyoutest.com/image.php/shop/data/upload/media/store/13/image/20200723/1595488199294456.jpg!800x800.jpg"
                    alt=""
                  />
                </li>
              </ul>
            </div>
          </div>
        </el-col>
        <el-col :span="16">
          <div class="fr second-detail">
            <p class="dettitle">{{ info.name }}</p>
            <div class="introduce">
              <div class="ks clearfix">
                <div class="kuanshi fl">商城价 :</div>
                <div class="kuanshi-two fl kuanshi-two1">
                 <span class="dettitle">¥{{ info.realprice }} </span>
                  降价通知
                </div>
              </div>
              <div class="ks clearfix">
                <div class="kuanshi fl">市场价 :</div>
                <div class="kuanshi-two fl kuanshi-two1">
                  <span
                    >¥{{
                      info.price != null && info.price != ""
                        ? info.price
                        : info.marketprice
                    }}</span
                  >
                </div>
              </div>
              <div class="ks clearfix">
                <div class="kuanshi fl">配送 :</div>
                <div class="kuanshi-two fl kuanshi-two1">
                  <el-cascader
                    v-model="cascaderAreaValue"
                    ref="cascaderAddr"
                    class="cascaderArea"
                    placeholder="发货地址"
                    :props="{ checkStrictly: true }"
                    :options="getprovince"
                    @change="areaHandleChange"
                  >
                  </el-cascader>
                  至
                  <el-cascader
                    v-model="shippingAreaValue"
                    ref="cascaderAddr"
                    class="cascaderArea"
                    placeholder="收货地址"
                    :props="{ checkStrictly: true }"
                    :options="getprovince"
                    @change="areaHandleChange"
                  >
                  </el-cascader>
                  <div style="margin: 10px 0px 20px 0">有货,下单后立即发送</div>
                </div>
              </div>
              <div class="ks clearfix">
                <div class="kuanshi fl">服务 :</div>
                <div class="kuanshi-two fl kuanshi-two1">
                  由 <a href=""> 本网站 </a> 发货并提供售后服务 [ 快递：¥{{
                    info.postage || 0.0
                  }}
                  ]
                </div>
              </div>
              <div class="ks clearfix">
                <div class="kuanshi fl">红包 :</div>
                <div class="kuanshi-two fl kuanshi-two1">可用0个</div>
              </div>
              <div class="ks clearfix">
                <div class="kuanshi fl">规格 :</div>
                <div class="kuanshi-two fl kuanshi-two2">
                  <el-radio-group v-model="goodsSize" size="medium">
                    <el-radio
                      border
                      :label="item.bXySid"
                      @change="getgoodsSize(item.realprice, item.bXySid)"
                      v-for="(item, index) in info.specificationlist"
                      :key="index"
                      >{{ item.name }}</el-radio
                    >
                  </el-radio-group>
                </div>
                <span class="select_c" id="select_c"
                  ><i></i>&nbsp;请输入选择材质</span
                >
              </div>
              <div class="ks clearfix">
                <div class="kuanshi fl">数量 :</div>
                <div class="number fl">
                  <el-input-number
                    v-model="info.number"
                    @change="handleChange"
                    :min="1"
                    :max="10"
                    label="描述文字"
                  ></el-input-number>
                </div>
              </div>

              <div class="buygoods">
                <a
                  href="javascript:;"
                  class="rightnow2 fl"
                  id="rightnow2"
                  @click="orderNow"
                  >立即购买</a
                >
                <a
                  href="javascript:;"
                  style="color: white"
                  class="addcar2 fl"
                  id="addcar2"
                  @click="onAddCar(info.id, info.number, info.bXySid)"
                >
                  <i class="addshopcar"></i>加入购物车</a
                >
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-dialog> -->
    <!-- 打开商品详情信息 结束 -->

    <!-- 加入购物车弹框 -->
    <el-dialog
      class="addCartBox"
      :visible.sync="addDialogVisible"
      width="30%"
      center
    >
      <div style="text-align: center" v-show="successInfo">
        <div class="addGoodsInfo">已成功加入购物车！</div>
        <!-- <div>{{ addGoodsName }}</div> -->
        <span slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">继续购物</el-button>
          <el-button type="primary" @click="$router.push('/shoppingcart')"
            >去购物车结算</el-button
          >
        </span>
      </div>
      <div style="text-align: center" v-show="!successInfo">
        <div>需要登录</div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="addDialogVisible = false"
            >确定</el-button
          >
        </span>
      </div>
    </el-dialog>
    <!-- 加入购物车结束 -->
  </div>
</template>
<script>
import { commoditylist, addShoppingCart, area_list,footprint_list } from "@/api/xunyou";
import goodsCard from '@/components/goodsCard'
// import {mapState,mapMutations} from 'vuex'
export default {
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
      loading:false,
      successInfo: true,
      addDialogVisible: false,
      openGoodsVisible: false,
      goodsList: [
        {
          id: 1,
          name: "鱼尾旗袍新款改良复古修身蕾丝中式旗袍 黄色 蕾丝",
          realprice: 368,
          evaluator: 3,
          photos: '/profile/upload/2020/12/15/5208d770b994939b56cfb6dce2ba5a57.jpg'
        },
        {
          id: 2,
          name: "鱼尾旗袍新款改良复古修身蕾丝中式旗袍 黄色 蕾丝",
          realprice: 368,
          evaluator: 3,
          photos: '/profile/upload/2020/12/15/5208d770b994939b56cfb6dce2ba5a57.jpg'
        }
      ],
      info: {
        searchValue: null,
        createBy: "",
        createTime: "2020-11-27 15:28:07",
        updateBy: "",
        updateTime: null,
        remark: "",
        params: {},
        id: 17,
        cid: "10",
        sid: "1",
        tag: "",
        name: "有机西兰花绿花椰菜新鲜有机蔬菜宝宝辅食 200g",
        adWord: "中国欧盟美国有机认证 农场现摘 品质保障",
        type: 1,
        photos:
          "/profile/upload/2020/11/27/4653959cf45dc8c6cb6ee84bb7c3e3f6.jpg",
        video: "",
        marketprice: "16",
        realprice: "16",
        needPoints: "200",
        stock: "9999",
        serialNumber: "",
        description: "有机西兰花绿花椰菜新鲜有机蔬菜宝宝辅食 200g",
        deliveryPlace: "安徽省",
        postage: "10",
        maxNum: 0,
        addedTime: "2020-11-27 00:00:00",
        buttonName: "",
        status: 1,
        addShelfSwitch: null,
        mid: 30,
        brandId: "",
        exchangeValue: null,
        pointsPrice: 10,
        producttype: "",
        attributes: "",
        salesnum: "",
        uid: null,
        approvalStatus: 1,
        number: null,
        cart_select: null,
        scid: null,
        checked: false,
      },
      goodsSize: "",
      num1: 1, //商品数量
      // getprovince: [], // 地址联动
      cascaderAreaValue: [], // 发货地址
      shippingAreaValue: [], // 收货地址
    };
  },
  // 注册组件
  components: {goodsCard},
  //  computed:{
  //   ...mapState(['getprovince'])
  // },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},
  mounted() {
    // this.getprovinceList();
    this.getfootList()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    // 查询我的足迹
  getfootList() {
    this.loading = true;
      footprint_list({uid:this.userInfo.userId||''})
        .then((res) => {
          if (res.code == 0) {
            this.loading = false;
            this.goodsList = res.rows;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("我的足迹查询失败，请稍后再试！");
        });
    },

    //   打开商品详情弹框
    openGoodsInfo() {
      console.log("打开", this.openGoodsVisible);
      this.openGoodsVisible = true;
    },
    beforeClose() {
      console.log("关闭", this.openGoodsVisible);
      this.openGoodsVisible = false;
    },
    // 填写地址选择
    areaHandleChange(value) {
      this.$refs["cascaderAddr"].getCheckedNodes();
      this.ruleForm.areaid = value[value.length - 1];
      //   console.log(this.cascaderAreaValue, this.ruleForm.areaid, "填写地址选择");
    },

    // 获取地址
    // getprovinceList() {
    //   area_list()
    //     .then((res) => {
    //       if (res.code == 0) {
    //         this.getprovince = res.data;
    //       } else {
    //         this.$message({
    //           type: "info",
    //           message: res.msg,
    //         });
    //       }
    //     })
    //     .catch((err) => {
    //       //   this.editFormVisible = false;
    //       this.loading = false;
    //       this.$message.error("获取地址失败，请稍后再试！");
    //     });
    // },

    // 选规格价格发生变化
    getgoodsSize(value, updateprice) {
      this.info.realprice = value;
      // this.updateprice = updateprice;
    },
    // 计数量
    handleChange(value) {
      console.log(value);
      // this.info.marketprice = value*this.info.marketprice;
    },

    // 加入购物车
    onAddCar(id, number, bXySid) {
      // if(this.userInfo.userName==null||this.userInfo.userName=="" ){
      //   this.$router.push('/login')
      //   return
      // }
      // if(this.goodsSize == ''){
      //   this.$message({
      //      type: 'info',
      //      message: '请选择规格'
      //    })
      //    return
      // }
      //  addShoppingCart({
      //   cid: id,
      //   uid: this.userInfo.userId,
      //   number:number,
      //   bxysid:this.goodsSize
      // })
      //   .then((res) => {
      //       if (res.code == 0) {
      //         console.log("res", res);
      //         this.addDialogVisible = true;
      //       }
      //   })
      //   .catch((err) => {
      //     this.loading = false;
      //     this.$message.error("添加购物车失败，请稍后再试！");
      //   });
    },
    // 立即下单
    orderNow() {
      // let selectList = [];
      // let goodList = [];
      // goodList.push({
      //   ...this.info
      // })
      //  let obj = {
      //   name:this.info.name,
      //   goods:goodList
      // }
      //  selectList.push(obj)
      //  sessionStorage.setItem("selectList", JSON.stringify(selectList));
      //  this.$router.push('/orderDetail')
    },

    //   加入购物车
    addCart(id, name, specificationlist) {
      this.addDialogVisible = true;
      // addShoppingCart({
      //     cid: id,
      //     uid: this.userInfo.userId,
      //     number: 1,
      //     bxysid:specificationlist.length>0?specificationlist[0].bXySid:''
      // })
      //     .then((res) => {
      //         if (res.code == 0) {
      //         console.log("res", res);
      //         this.addGoodsName = name;
      //         this.centerDialogVisible = true;

      //         }
      //     })
      //     .catch((err) => {
      //     this.loading = false;
      //     this.$message.error("添加购物车失败，请稍后再试！");
      //     });
    },
  },
};
</script>

<style scoped lang="less">
.rightaside_content {
  .headerTitle {
    font-size: 20px;
    height: 40px;
    line-height: 40px;
    color: #666;
    margin-bottom: 20px;
  }
  /deep/.el-tabs--border-card {
    border: 0px;
    box-shadow: unset;
    .el-tabs__header {
      border-bottom: 0px;
      background: white;
      /deep/ .el-tabs__item.is-active {
        color: #78b942;
        background-color: transparent;
        border-right-color: transparent;
        border-left-color: transparent;
      }
    }
  }

//  .wholeInfoBox {
//     // width: 80%;
//     height: auto;
//     border: 1px solid #e4e4e4;
//     padding: 10px;
//     box-sizing: border-box;
//     position: relative;
//     margin-bottom: 20px;
//     .addCartOpreate {
//       display: none;
//       position: absolute;
//       left: 0;
//       right: 0;
//       bottom: 70px;
//       width: 100%;
//       background-color: rgba(0, 0, 0, 0.4);
//       color: #fff;
//       text-align: center;
//       line-height: 40px;
//       transition: all 0.45s ease;
//     }
//     .attentiontOpreate {
//       display: none;
//       position: absolute;
//       right: 10px;
//       top: 10px;
//       .el-button--warning {
//         color: #fff;
//         background-color: rgba(0, 0, 0, 0.4);
//         font-size: 16px;
//         border-color: transparent;
//         display: block;
//         margin-left: 0 !important;
//         margin-bottom: 10px;
//       }
//     }
//     .el-el-image {
//       width: 100%;
//       height: auto;
//     }
//     .goodsText {
//       text-align: center;
//       margin-bottom: 4px;
//     }
//     .mark {
//       display: none;
//       font-size: 14px;
//       background: rgba(255, 255, 255, 0.8);
//       position: relative;
//       .redeemNow {
//         background: #78b942;
//         padding: 6px;
//         text-align: center;
//         color: white;
//         cursor: pointer;
//         position: absolute;
//         left: 50%;
//         transform: translate(-50%);
//         border-radius: 6px;
//       }
//       .redeemNow:hover {
//         background-color: rgba(34, 34, 34, 0.85);
//       }
//     }
//   }
//   .wholeInfoBox:hover {
//     .addCartOpreate {
//       display: block;
//       cursor: pointer;
//     }
//     .addCartOpreate:hover {
//       background: #78b942;
//     }
//     .attentiontOpreate {
//       display: block;
//       cursor: pointer;
//     }
//     .el-button--warning:hover {
//       background: #78b942;
//     }
//   }

  .no_goods {
    text-align: center;
    line-height: 24px;
    font-size: 14px;
  }
}
 .addCartInfoBox {
        .cascaderArea.el-cascader {
            /deep/input[disabled],
            /deep/input[disabled="disabled"],
            /deep/input[readonly],
            /deep/input[readonly="readonly"] {
            background-color: white;
            }
        }
      }
// }
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/myOrder/attentionCenter/myFooter.vue